var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #000a3c;\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200,0C89.54,0,0,89.54,0,200s89.54,200,200,200,200-89.54,200-200S310.46,0,200,0Zm103.38,150.66c8.54,118.91-119.56,191.17-223.36,132.05,0,0,51.24,2.63,72.92-22.34,0,0-31.53,2.63-47.3-35.48,0,0,11.83,4.6,23.65-1.31,0,0-36.79-5.91-40.07-49.93,0,0,11.83,9.2,24.96,5.91,0,0-40.73-24.31-17.74-68.32,0,0,43.36,55.18,105.77,53.21-9.85-51.9,52.56-82.78,89.34-45.33,0,0,16.42-4.6,30.88-13.8,0,0-5.26,17.74-22.99,28.91,0,0,19.71-2.63,28.25-7.88,0,0-8.54,17.74-24.31,24.31Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.f33a8f46845c2abb3a4163aa0c6feb76.svg";
export { ForwardRef as ReactComponent };